import { type FieldValues, useController } from 'react-hook-form';

import type { ComponentProps } from '~/chords/ComponentProps';
import { FormField, type FormFieldProps } from '~/chords/FormField';
import type { TextAreaProps } from '~/components/TextArea';
import { TextArea } from '~/components/TextArea';

type FormFieldTextAreaProps<TFormFields extends FieldValues> = ComponentProps<
  Omit<FormFieldProps<TFormFields>, 'children'> &
    Omit<TextAreaProps, 'name' | 'className'>
>;

export function FormFieldTextArea<TFormFields extends FieldValues>({
  name,
  label,
  dangerouslyOverrideClassName,
  disabled = false,
  readOnly = false,
  ...textAreaProps
}: FormFieldTextAreaProps<TFormFields>) {
  const {
    field,
    fieldState: { invalid },
  } = useController({ name, disabled });

  return (
    <FormField
      name={name}
      label={label}
      dangerouslyOverrideClassName={dangerouslyOverrideClassName}
      disabled={disabled}
      readOnly={readOnly}
    >
      <TextArea
        id={name}
        {...field}
        state={invalid ? 'error' : undefined}
        {...textAreaProps}
        disabled={disabled}
        readOnly={readOnly}
      />
    </FormField>
  );
}

FormFieldTextArea.displayName = 'FormFieldTextArea';
